import React, { useContext } from 'react';
import { StateContext } from "../../../state/index";
import LoadingPage from "../../library/LoadingPage";

export const OAuthView = ({isReturningFromOauth}) => {
  const [{configuration}] = useContext(StateContext);
  const { returningFromOauth, redirectingToOauth } = configuration.recipientLogin;

  return <LoadingPage {...(isReturningFromOauth ? returningFromOauth : redirectingToOauth)}/>
};

export default OAuthView;
